"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/NewChat/Cards.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _myRelations = require('shared/selectors/myRelations');
var _user = require('shared/selectors/user');
var _entity = require('shared/services/entity');
var _phone = require('shared/services/phone');


var _newChatFlow = require('shared/services/createNew/newChatFlow');
var _chat = require('shared/validation/createNew/chat');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _hooks = require('web/services/hooks');
var _Avatar = require('web/components/Avatar');
var _ClickExplainer = require('web/components/SecureText/ClickExplainer'); var _ClickExplainer2 = _interopRequireDefault(_ClickExplainer);


var _icons = require('../Compose/icons');
var _parts = require('./parts');

const EMPTY_ORG_ENTITIES = []

/* The New group and patient steps as cards (design round 8 A), as on
 * mobile: who it's with and the chat's name; Send as / Send from; the
 * members as a grid of avatars with an Add tile. */












 const CardsStep = ({
  chat, step, onBack, onAction, isBusy, onSendFrom, onAddPeople, error,
}) => {
  const members = chat.selectedEntitiesList
  const cards = _newChatFlow.cardsFor.call(void 0, { step, hasPatient: !!chat.patient, textingTeams: chat.phoneTeamsForPatient.length })
  const isSms = chat.channel === 'insecure' && cards.showSendAs
  const [isSendAsOpen, setIsSendAsOpen] = _react.useState.call(void 0, false)
  const closeSendAs = _react.useCallback.call(void 0, () => setIsSendAsOpen(false), [])
  const pickChannel = (channel) => {
    chat.setChannel(channel)
    setIsSendAsOpen(false)
  }
  return (
    _react2.default.createElement('div', { className: "new-chat-cards", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      , _react2.default.createElement(_parts.Header, { left: "back", onLeft: onBack, title: cards.title, action: cards.action, isActionEnabled: members.length > 0, isActionBusy: isBusy, onAction: onAction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}} )
      , _react2.default.createElement('div', { className: "new-chat-cards--scroll", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
        , _react2.default.createElement(_parts.ErrorLine, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}} )
        , _react2.default.createElement('div', { className: "new-chat-cards--card new-chat-cards--identity" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          ,  step === 'group'
            ? _react2.default.createElement(GroupAvatar, { front: chat.senderEntity, back: members[0], __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} )
            : members[0] && _react2.default.createElement(_Avatar.EntityAvatar, { entity: members[0], size: 56, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}} ) 
          , _react2.default.createElement(NameField, { chat: chat, label: cards.nameLabel, isSms: isSms, autoFocus: !isSms, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}} )
        )
        ,  !isSms && _react2.default.createElement('div', { className: "new-chat-cards--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}},  _newChatFlow.NAME_HELP ) 
        ,  (cards.showSendAs || cards.showSendFrom) && (
          _react2.default.createElement('div', { className: "new-chat-cards--card new-chat-cards--settings" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
            ,  cards.showSendAs && (
              _react2.default.createElement('div', { className: "new-chat-cards--row-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
                , _react2.default.createElement('button', { type: "button", className: "new-chat-cards--row", 'aria-label': `Send as, ${isSms ? _newChatFlow.SMS_OPTION.title : _newChatFlow.SECURE_OPTION.title}`, onClick: () => setIsSendAsOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
                  , _react2.default.createElement('span', { className: "new-chat-cards--row-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, "Send as" )
                  , _react2.default.createElement('span', { className: "new-chat-cards--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}} )
                  , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'new-chat-cards--row-value', isSms && 'new-chat-cards--row-value---warn'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
                    ,  isSms ? _react2.default.createElement(_icons.UnlockIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}} ) : _react2.default.createElement(_icons.LockIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}} ) 
                    ,  isSms ? _newChatFlow.SMS_OPTION.title : _newChatFlow.SECURE_OPTION.title 
                  )
                  , _react2.default.createElement(_icons.ChevronRightIcon, { size: 16, className: "new-chat-cards--chev", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}} )
                )
                , _react2.default.createElement(_ClickExplainer2.default, { className: "new-chat-cards--info", label: "Secure vs. SMS text"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
                  , _react2.default.createElement(_icons.InfoIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}} )
                )
                ,  isSms && (
                  _react2.default.createElement('div', { className: "new-chat-cards--phi", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
                    , _react2.default.createElement(_icons.WarnIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}} )
                    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 85}},  _newChatFlow.PHI_WARNING )
                  )
                )
              )
            )
            ,  cards.showSendFrom && _react2.default.createElement(SendFromRow, { chat: chat, onClick: onSendFrom, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}} ) 
          )
        )
        , _react2.default.createElement('div', { className: "new-chat-cards--cap", role: "heading", 'aria-level': 4, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}},  `Members · ${members.length}` )
        , _react2.default.createElement('div', { className: "new-chat-cards--grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
          , _react2.default.createElement('button', { type: "button", className: "new-chat-cards--tile", 'aria-label': "Add people" , onClick: onAddPeople, __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
            , _react2.default.createElement('span', { className: "new-chat-cards--add", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, _react2.default.createElement(_icons.PlusIcon, { size: 22, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}} ))
            , _react2.default.createElement('span', { className: "new-chat-cards--tile-label new-chat-cards--tile-label---add" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "Add")
          )
          ,  members.map(entity => (
            _react2.default.createElement('div', { key: entity.entityKey, className: "new-chat-cards--tile", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
              , _react2.default.createElement('span', { className: "new-chat-cards--tile-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
                , _react2.default.createElement(_Avatar.EntityAvatar, { entity: entity, size: 52, __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}} )
                , _react2.default.createElement('button', {
                  type: "button",
                  className: "new-chat-cards--remove",
                  'aria-label': `Remove ${entity.name}`,
                  onClick: () => chat.onRemoveEntity(entity.entityKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}

                  , _react2.default.createElement(_icons.CloseIcon, { size: 12, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}} )
                )
              )
              , _react2.default.createElement('span', { className: "new-chat-cards--tile-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}},  _newChatFlow.tileLabel.call(void 0, entity) )
            )
          ))
        )
      )
      ,  isSendAsOpen && _react2.default.createElement(SendAsPanel, { chat: chat, onPick: pickChannel, onClose: closeSendAs, __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}} ) 
    )
  )
}; exports.CardsStep = CardsStep

const GroupAvatar = ({ front, back }) => (
  _react2.default.createElement('span', { className: "new-chat-cards--group-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
    ,  back && _react2.default.createElement('span', { className: "new-chat-cards--group-back", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}, _react2.default.createElement(_Avatar.EntityAvatar, { entity: back, size: 37, __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}} )) 
    ,  front && _react2.default.createElement('span', { className: "new-chat-cards--group-front", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}, _react2.default.createElement(_Avatar.EntityAvatar, { entity: front, size: 37, __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}} )) 
  )
)

// "Group name" / "Chat name": the label always sits above the input, with
// the placeholder in it. Not for SMS.
const NameField = ({ chat, label, isSms, autoFocus }) => {
  const field = _newChatFlow.nameFieldFor.call(void 0, isSms ? 'insecure' : 'secure')
  return (
    _react2.default.createElement('label', { className: _classBuilder2.default.call(void 0, 'new-chat-cards--field', !field.isEnabled && 'new-chat-cards--field---off'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}
      , _react2.default.createElement('span', { className: "new-chat-cards--float", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}},  label )
      , _react2.default.createElement('input', {
        className: "new-chat-cards--input",
        'aria-label': field.isEnabled ? `${label}, optional` : `${label}, ${field.placeholder}`,
        placeholder: field.placeholder,
        value: field.isEnabled ? chat.name : '',
        disabled: !field.isEnabled,
        maxLength: _chat.MAX_NAME_LENGTH,
        autoFocus: autoFocus,
        onChange: e => chat.setName(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}
      )
    )
  )
}

const SendFromRow = ({ chat, onClick }) => {
  const sender = chat.isInsecure && !chat.isPhoneSender ? null : chat.senderEntity
  return (
    _react2.default.createElement('button', { type: "button", className: "new-chat-cards--row", 'aria-label': sender ? `Send from, ${sender.name}` : 'Send from, choose a team', onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
      , _react2.default.createElement('span', { className: "new-chat-cards--row-label new-chat-cards--grow" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}, "Send from" )
      ,  sender
        ? _react2.default.createElement('span', { className: "new-chat-cards--row-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}, _react2.default.createElement(_Avatar.EntityAvatar, { entity: sender, size: 24, __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}} ),  sender.name )
        : _react2.default.createElement('span', { className: "new-chat-cards--row-placeholder", __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}, "Choose a team"  ) 
      , _react2.default.createElement(_icons.ChevronRightIcon, { size: 16, className: "new-chat-cards--chev", __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}} )
    )
  )
}

// A small panel at the bottom of the modal: Secure text or SMS text.
const SendAsPanel = ({ chat, onPick, onClose }) => {
  // Escape closes the panel and goes no further (the modal steps back on
  // Escape's keyup); focus moves into it.
  const panelRef = _react.useRef(null)
  _react.useEffect.call(void 0, () => {
    _optionalChain([panelRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.querySelector, 'call', _3 => _3('[aria-checked="true"]'), 'optionalAccess', _4 => _4.focus, 'call', _5 => _5()])
    const onKeyUp = (e) => {
      if (e.key !== 'Escape') return
      e.stopPropagation()
      onClose()
    }
    window.addEventListener('keyup', onKeyUp, true)
    return () => window.removeEventListener('keyup', onKeyUp, true)
  }, [onClose])
  const myName = _hooks.useAppSelector.call(void 0, state => _optionalChain([_user.selectCurrentUserV2.call(void 0, state), 'optionalAccess', _6 => _6.Name]))
  const sender = chat.senderEntity && _entity.isEntityTeam.call(void 0, chat.senderEntity) && chat.isPhoneSender ? chat.senderEntity : null
  const smsDescription = chat.blockedReason
    || _newChatFlow.SMS_OPTION.description(_nullishCoalesce(_optionalChain([sender, 'optionalAccess', _7 => _7.name]), () => ( null)), chat.senderPhone)
  return (
    _react2.default.createElement('div', { className: "new-chat-cards--overlay", onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
      , _react2.default.createElement('div', { ref: panelRef, className: "new-chat-cards--panel", role: "dialog", 'aria-label': "Send as" , onClick: e => e.stopPropagation(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
        , _react2.default.createElement('div', { className: "new-chat-cards--panel-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
          , _react2.default.createElement('span', { className: "new-chat--header-space", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}} )
          , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}, "Send as" )
          , _react2.default.createElement('button', { type: "button", className: "new-chat--icon-btn", 'aria-label': "Close", onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}, _react2.default.createElement(_icons.CloseIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}} ))
        )
        , _react2.default.createElement('div', { role: "radiogroup", 'aria-label': "Send as" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}
          , _react2.default.createElement(SendAsOption, {
            channel: "secure",
            title: _newChatFlow.SECURE_OPTION.title,
            description: _newChatFlow.SECURE_OPTION.description(_nullishCoalesce(_optionalChain([chat, 'access', _8 => _8.patient, 'optionalAccess', _9 => _9.name]), () => ( '')), myName),
            isOn: chat.channel === 'secure',
            onPick: onPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}}
          )
          , _react2.default.createElement(SendAsOption, {
            channel: "insecure",
            title: _newChatFlow.SMS_OPTION.title,
            description: smsDescription,
            warning: chat.blockedReason ? undefined : _newChatFlow.PHI_WARNING,
            isOn: chat.channel === 'insecure',
            isDisabled: !!chat.blockedReason,
            onPick: onPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}
          )
        )
      )
    )
  )
}











const SendAsOption = ({ channel, title, description, warning, isOn, isDisabled, onPick }) => {
  const isSms = channel === 'insecure'
  return (
    _react2.default.createElement('button', {
      type: "button",
      role: "radio",
      'aria-checked': isOn,
      'aria-label': `${title}. ${description}`,
      disabled: isDisabled,
      className: _classBuilder2.default.call(void 0, 'new-chat-cards--option', isDisabled && 'new-chat-cards--option---off'),
      onClick: () => onPick(channel), __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}}

      , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'new-chat--shortcut-icon', isSms && 'new-chat--shortcut-icon---sms'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}
        ,  isSms ? _react2.default.createElement(_icons.UnlockIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}} ) : _react2.default.createElement(_icons.LockIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}} ) 
      )
      , _react2.default.createElement('span', { className: "new-chat-cards--option-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 239}},  title )
        , _react2.default.createElement('small', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 240}},  description )
        ,  warning && _react2.default.createElement('small', { className: "new-chat-cards--warn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}},  warning ) 
      )
      ,  isOn ? _react2.default.createElement(_icons.CheckIcon, { size: 20, className: "new-chat-cards--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}} ) : _react2.default.createElement('span', { className: "new-chat-cards--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}} ) 
    )
  )
}









 const SendFromStep = ({ chat, onBack, onPick, isPatient }) => {
  const myEntities = _hooks.useAppSelector.call(void 0, _myRelations.selectMyEntities)
  const orgsList = 'orgsList' in myEntities ? myEntities.orgsList : EMPTY_ORG_ENTITIES
  const [query, setQuery] = _react.useState.call(void 0, '')
  const phoneTeamKeys = _react.useMemo.call(void 0, () => new Set(chat.phoneTeamsForPatient.map(t => t.TeamKey )), [chat.phoneTeamsForPatient])
  const matches = (e) => !query || e.name.toLowerCase().includes(query.toLowerCase())
  const selectedKey = _optionalChain([chat, 'access', _10 => _10.senderEntity, 'optionalAccess', _11 => _11.entityKey])
  const patientFirst = chat.patient ? _newChatFlow.firstName.call(void 0, chat.patient.name) : ''
  const you = isPatient ? [] : orgsList.filter(matches)
  const teams = myEntities.teamsList.filter(t => (!isPatient || phoneTeamKeys.has(t.entityKey)) && matches(t))
  const row = (entity) => {
    const phone = isPatient && _entity.isEntityTeam.call(void 0, entity) ? _phone.formatPhoneNumber.call(void 0, (entity.wrappedEntity ).PhoneNumber) : ''
    const isOn = entity.entityKey === selectedKey
    return (
      _react2.default.createElement('button', {
        key: entity.entityKey,
        type: "button",
        className: "new-chat-cards--pick",
        'aria-pressed': isOn,
        'aria-label': phone ? `${entity.name}, ${phone}` : entity.name,
        onClick: () => onPick(entity.entityKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}

        , _react2.default.createElement(_Avatar.EntityAvatar, { entity: entity, size: 32, __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}} )
        , _react2.default.createElement('span', { className: "new-chat-cards--pick-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 280}},  entity.name )
          ,  phone && _react2.default.createElement('small', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 281}},  phone ) 
        )
        ,  isOn ? _react2.default.createElement(_icons.CheckIcon, { size: 20, className: "new-chat-cards--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 283}} ) : _react2.default.createElement('span', { className: "new-chat-cards--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 283}} ) 
      )
    )
  }
  return (
    _react2.default.createElement('div', { className: "new-chat-cards", __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}}
      , _react2.default.createElement(_parts.Header, { left: "back", onLeft: onBack, title: "Send from" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 289}} )
      , _react2.default.createElement('div', { className: "new-chat-cards--scroll", __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
        ,  !isPatient && (
          _react2.default.createElement('label', { className: "new-chat-cards--search", __self: this, __source: {fileName: _jsxFileName, lineNumber: 292}}
            , _react2.default.createElement(_icons.SearchIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}} )
            , _react2.default.createElement('input', { placeholder: "Search", 'aria-label': "Search senders" , value: query, onChange: e => setQuery(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 294}} )
          )
        )
        ,  isPatient
          ? (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('div', { className: "new-chat-cards--cap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}}, "Texting teams for "   ,  patientFirst )
                , _react2.default.createElement('div', { className: "new-chat-cards--card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 301}},  teams.map(row) )
                , _react2.default.createElement('div', { className: "new-chat-cards--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}},  patientFirst , " gets texts from this team's number."      )
              )
            )
          : (
              _react2.default.createElement(_react2.default.Fragment, null
                ,  !!you.length && _react2.default.createElement('div', { className: "new-chat-cards--cap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 307}}, "You") 
                ,  !!you.length && _react2.default.createElement('div', { className: "new-chat-cards--card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 308}},  you.map(row) ) 
                ,  !!teams.length && _react2.default.createElement('div', { className: "new-chat-cards--cap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 309}}, "Teams") 
                ,  !!teams.length && _react2.default.createElement('div', { className: "new-chat-cards--card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}},  teams.map(row) ) 
              )
            )
      )
    )
  )
}; exports.SendFromStep = SendFromStep
